import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=735853ea&"
import script from "./demo.vue?vue&type=script&lang=js&"
export * from "./demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('735853ea')) {
      api.createRecord('735853ea', component.options)
    } else {
      api.reload('735853ea', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=735853ea&", function () {
      api.rerender('735853ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/formSys/demo.vue"
export default component.exports